import { useMutation } from "react-query";
import { createEducationHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useCreateEducationHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      createEducationHistory(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while saving the education history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    createEducationHistoryMutation: mutate,
    isCreateEducationHistoryLoading: isLoading,
    ...rest,
  };
};

export default useCreateEducationHistory;
